export { Divide as default } from './Divide';
